import React, { useContext } from 'react';
import { Table, Tag } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'moment';
import AppContext from '../../../../context/Context';

const LogsDisplay = ({ logs, loading }) => {
    const {
    config: { isDark },
  } = useContext(AppContext);
  const brokersList = useSelector((state) => state?.brokers?.list || []);
  const getBrokerLabel = (id) => {
    const b = (brokersList || []).find(x => (x?.id?.toString?.() || '') === id?.toString?.());
    if (!b) return id;
    return b?.name?.toUpperCase() || `${b?.type?.toUpperCase?.()} - ${b?.userName?.toUpperCase?.()}` || id;
  };

  // Helper functions for logs
  const formatTimestamp = (tsMicros) => {
    if (!tsMicros) return '-';
    return moment(tsMicros / 1000).format('HH:mm:ss.SSS');
  };

  return (
    <div style={{ width: '70vw', overflow: 'hidden' }}>
      <Table
        dataSource={logs}
        loading={loading}
        rowKey={(record, index) => `log-${index}`}
        size="small"
        scroll={{ y: 600, x: 'max-content' }}
        pagination={false}
        columns={[
          {
            title: 'TIMESTAMP',
            dataIndex: 'tsMicros',
            key: 'timestamp',
            align: 'left',
            sorter: (a, b) => (a.tsMicros || 0) - (b.tsMicros || 0),
            render: (tsMicros) => <span style={{fontSize: '12px'}}>{formatTimestamp(tsMicros)}</span>,
            width: 120,
          },
          {
            title: 'LOG TYPE',
            dataIndex: 'color',
            key: 'logType',
            align: 'center',
            width: 100,
            render: (color) => {
              let tagColor = 'blue';
              let label = 'INFO';
              switch (color?.toLowerCase()) {
                case 'red':
                  tagColor = 'error';
                  label = 'ERROR';
                  break;
                case 'yellow':
                case 'orange':
                  tagColor = 'warning';
                  label = 'WARNING';
                  break;
                case 'green':
                  tagColor = 'success';
                  label = 'SUCCESS';
                  break;
                case 'gray':
                case 'blue':
                default:
                  tagColor = 'blue';
                  label = 'INFO';
                  break;
              }
              return <Tag color={tagColor}>{label}</Tag>;
            },
          },
          {
            title: 'BROKER',
            dataIndex: 'brokerId',
            key: 'broker',
            align: 'center',
            width: 150,
            render: (brokerId) => {
              if (brokerId == null) return '-';
              return <Tag color="purple">{getBrokerLabel(brokerId)}</Tag>;
            },
          },
          {
            title: 'MESSAGE',
            dataIndex: 'msg',
            key: 'message',
            sorter: (a, b) => {
              const aMsg = ((a.msg || '') + ' ' + (a.description || '')).toUpperCase();
              const bMsg = ((b.msg || '') + ' ' + (b.description || '')).toUpperCase();
              return aMsg.localeCompare(bMsg);
            },
            render: (msg, record) => {
              const description = record.description || '';
              return (
                <span style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '12px', textAlign: 'left' }}>
                  {msg || '-'}
                  {description && (
                    <span style={{ fontSize: '11px', color: isDark ? '#C6C6C6' : '#666', fontStyle: 'italic', textAlign: 'left' }}>
                      {description}
                    </span>
                  )}
                </span>
              );
            },
            ellipsis: true,
          },
        ]}
        locale={{ emptyText: 'No logs available' }}
      />
    </div>
  );
};

export default LogsDisplay;
